import { render, staticRenderFns } from "./ChartPie.vue?vue&type=template&id=1b4d2246&scoped=true"
import script from "./ChartPie.vue?vue&type=script&lang=js"
export * from "./ChartPie.vue?vue&type=script&lang=js"
import style0 from "./ChartPie.vue?vue&type=style&index=0&id=1b4d2246&prod&scoped=true&lang=css"
import style1 from "./ChartPie.vue?vue&type=style&index=1&id=1b4d2246&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b4d2246",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VSheet } from 'vuetify/lib/components/VSheet';
installComponents(component, {VProgressCircular,VSheet})
